module.exports = __webpack_public_path__ + "media/images/Add2-eaef5c8008b5eb34d794fc38ccfe00aa.svg";